<template>
  <div class="product-card card">
    <b-img
      class="card-img-top"
      alt="Card image cap"
      :src="`${product.img_path}`"
      rounded
    />
    <div class="card-body">
      <h4 class="card-title card-name">{{ product.product_name }}</h4>
      <p class="prodCategory">
        {{ $tc('category', 1) }}: {{ product.category_name }}
      </p>
      <p class="prodCategory">
        {{ $tc('taxRate', 1) }}: {{ product.category_tax_rate }}
      </p>
      <p class="supplierAddress">{{ product.client_address }}</p>

      <div class="description">
        {{ product.description }}
      </div>
      <div class="pricingDetails">
        <div class="priceRange">
          {{ $t('wholesale_priceShort') }}: {{ product.wholesale_price }}
        </div>
        <div class="MOQ">
          {{ $t('moqShort') }}: <span>{{ product.moq }}</span> PCS.
        </div>
        <div class="suggSellingPrice">
          <div>
            ({{ $t('sugg_selling_priceShort') }}:
            <span>{{ product.sugg_selling_price }}</span> EUR)
          </div>
        </div>
        <!-- <div><TrashIcon v-on:click.native="deleteFromMarketPlace" /></div> -->
      </div>
      <!-- <div class="add-btn" v-if="product.verified === 1">
        {{ $t('addedToMarketPlace') }}
      </div> -->

      <div v-if="product.verified === 1">
        <span class="a"
          ><TrashIcon v-on:click.native="deleteFromMarketPlace"
        /></span>
        <span class="b">
          <div class="add-btn">
            {{ $t('addedToMarketPlace') }}
          </div>
        </span>
      </div>

      <div v-else>
        <span class="a"
          ><TrashIcon v-on:click.native="deleteFromMarketPlace"
        /></span>
        <span class="b">
          <button class="inquiry-btn" @click="addProduct(product)">
            {{ $t('addToMarketPlace') }}
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import TrashIcon from '@/components/common/TrashIcon'
export default {
  components: {
    TrashIcon
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    async addProduct() {
      const body = {
        product_id: this.product.product_id,
        product_name: this.product.product_name,
        email: this.product.client_email,
        client_name: this.product.client_name
      }
      await this.$store.dispatch(
        'marketPlace/addProductToMarketPlaceAdmin',
        body
      )
      this.$emit('refresh-products', null)
    },
    async deleteFromMarketPlace() {
      const body = {
        product_id: this.product.product_id,
        product_name: this.product.product_name,
        email: this.product.client_email,
        client_name: this.product.client_name
      }
      await this.$store.dispatch(
        'marketPlace/deleteProductFromMarketPlaceAdmin',
        body
      )
      this.$emit('refresh-products', null)
    }
  },
  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped>
h4 {
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.stock-general {
  display: inline;
}
.description {
  text-align: justify;
  font-size: 0.7rem;
}

.pricingDetails {
  text-align: left;
  margin-top: 10px;
}

.suggSellingPrice {
  font-size: 0.7rem;
}

span.a {
  float: left;
  width: 35px;
  margin-right: 20px;
  cursor: pointer;
  margin-top: 10px;
}

span.b {
  width: 150px;
}

.card-img-top {
  height: 100px;
  width: auto;
  margin: auto;
  max-width: 200px !important;
}
.card-body {
  /* flex: 1 1 auto;
    min-height: 1px; */
  padding: 0.25rem 0rem;
}
/* .card-name {
	color: #454655;
}
.card-text {
	color: #454655;
} */
.product-price {
  font-size: 2em;
}
.card-title {
  font-weight: 600;
  margin: auto;
}

.product-card {
  color: #454655;
  width: 250px;
  height: 100%;
  padding: 20px;
  margin: 10px;
  border-radius: 5px;
  min-height: 300px;
  background: var(--bg-ultraLight);
}

.product-card:hover {
  background: rgba(128, 128, 128, 0.315);
  color: var(--primaryDark);
  /* margin: 17px; */
  padding: 20px;
  border-radius: 5px;
}
.product-card:active {
  background: #707181;
  /* margin: 16px; */
  padding: 20px;
  border-radius: 5px;
}
.right {
  position: relative;
  float: right;
}

.add-btn {
  background: var(--primaryDark);
  border-radius: 5px;
  color: var(--bright);
  padding: 0.3em;
  text-transform: uppercase;
  letter-spacing: 0px;
  float: right;
  width: 150px;
  margin-top: 20px;
}
.trashIcon {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 1px;
  border: none;
  border-radius: 3.5px;
  width: 40px;
  height: 35px;
  position: relative;
  display: block;
  top: -25px;
  left: -33px;
}
.inquiry-btn {
  color: var(--bg-light) !important;
  border: 1px solid var(--bg-light);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 0.9em;
  padding: 5px 10px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
  margin: auto;
  width: 150px;
  margin-bottom: 10px;
  margin-top: 20px;
}

.inquiry-btn:hover {
  background: var(--primaryDark);
  color: var(--bright) !important;
}
.icon {
  font-size: 1.3em;
  padding: 1px;
  float: right;
  cursor: pointer;
}

@media only screen and (max-device-width: 500px) {
  .product-card {
    margin: auto;
  }
  .card {
    margin-bottom: 20px;
  }
}
</style>
